import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    KalCheckboxModule,
    KalIconModule,
    KaligraphiModule,
    KalOptionModule,
    KalSelectModule,
    KalUtilityModule
} from '@kalidea/kaligraphi';

import { KalTemplateOutlet } from './directives/kal-template-outlet.directive';
import {
    KalBodyCellDirective,
    KalBodyRowComponent,
    KalBodyRowDirective,
    KalBodyRowOutletDirective,
    KalCellsOutletDirective,
    KalColumnDirective,
    KalFooterCellDirective,
    KalFooterRowComponent,
    KalFooterRowDirective,
    KalFooterRowOutletDirective,
    KalHeaderCellDirective,
    KalHeaderRowComponent,
    KalHeaderRowDirective,
    KalHeaderRowOutletDirective
} from './kal-table-definitions';
import { KalTableComponent } from './kal-table.component';
import { ColumnFilterPositionDirective, KalTableHeaderComponent } from './kal-table-header/kal-table-header.component';
import { KalFixedTableDirective } from './kal-fixed-table.directive';
import { KalPaginatorComponent } from './kal-paginator/kal-paginator.component';
import { FormComponentsModule } from 'src/app/_shared/modules/form-component/form-components.module';

// les imports sont relatifs "exprès" de façon à pouvoir l'intégrer plus facilement à kaligraphi par la suite

export {
    KalBodyCellDirective,
    KalBodyRowComponent,
    KalBodyRowDirective,
    KalBodyRowOutletDirective,
    KalCellsOutletDirective,
    KalColumnDirective,
    KalFooterCellDirective,
    KalFooterRowComponent,
    KalFooterRowDirective,
    KalFooterRowOutletDirective,
    KalHeaderCellDirective,
    KalHeaderRowComponent,
    KalHeaderRowDirective,
    KalHeaderRowOutletDirective
} from './kal-table-definitions';
export { KalTableComponent, KalSelectionMode } from './kal-table.component';
export { KalTableGenericDatasource } from './classes/kal-table-generic-datasource';
export { KalTableDatasource, KalTableDatasourceParameters } from './classes/kal-table-datasource';
export { KalTableHeader } from './classes/kal-table-header';
export { KalTableSortEvent, KalTableSortDirection, KalTableSortManager } from './classes/managers/kal-table-sort-manager';
export { KalTableEventManager } from './classes/managers/kal-table-event-manager';
export { KalTableFiltersManager } from './classes/managers/kal-table-filters-manager';
export { KalTablePage, KalTablePageEvent, KalTablePageManager } from './classes/managers/kal-table-page-manager';
export * from './kal-paginator/kal-paginator.component';
export * from './directives/kal-template-outlet.directive';

const declarations = [
    KalTableComponent,
    KalColumnDirective,
    KalBodyCellDirective,
    KalFooterCellDirective,
    KalHeaderCellDirective,
    KalHeaderRowDirective,
    KalFooterRowDirective,
    KalBodyRowDirective,
    KalFooterRowOutletDirective,
    KalHeaderRowOutletDirective,
    KalBodyRowOutletDirective,
    KalFooterRowComponent,
    KalHeaderRowComponent,
    KalBodyRowComponent,
    KalCellsOutletDirective,
    KalFixedTableDirective,
    KalTableHeaderComponent,
    KalPaginatorComponent,
    KalTemplateOutlet,
    ColumnFilterPositionDirective
];

@NgModule({
    declarations,
    exports: declarations,
    imports: [
        CommonModule,
        ScrollingModule,
        DragDropModule,
        KalCheckboxModule,
        KalIconModule,
        KalUtilityModule,
        KalSelectModule,
        KalOptionModule,
        ReactiveFormsModule,
        FormsModule,
        KaligraphiModule,
        FormComponentsModule,
    ]
})
export class KalTableModule {
}
